import src from "IMAGE";
export default { src, width: 195, height: 42, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAQAAADPnVVmAAAALUlEQVR42gEiAN3/AAlBCCgCMgVCAz8AQAFNA08ABUEHKQU0BE0CQwAuADUCRUMxBAdLD93PAAAAAElFTkSuQmCC"};
